import { PropsWithChildren } from "react";
import { persistor } from "../../../store/store.ts";
import { PersistGate } from "redux-persist/integration/react";

const PersistGateWrapper = ({ children }: PropsWithChildren) => {
  return <PersistGate persistor={persistor}>{children}</PersistGate>;
};

export default PersistGateWrapper;
